import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import siteConfig from "../config/siteConfig";
import "../css/privacy.scss";

function Cookies() {
  useEffect(() => { document.title = `Cookie policy | ${siteConfig.brandName}`; }, []);

  return (
    <main className="policy-page cookie-page">
      <header className="policy-hero">
        <nav aria-label="Breadcrumb"><Link to="/">Home</Link><span>/</span><span>Cookies</span></nav>
        <p className="eyebrow">Last updated September 2026</p>
        <h1>Cookie policy</h1>
        <p>What this storefront stores in your browser and how you can control it.</p>
      </header>
      <div className="policy-layout">
        <aside aria-label="On this page"><a href="#cookie-use">Our use</a><a href="#cookie-essential">Essential storage</a><a href="#cookie-third-party">Third parties</a><a href="#cookie-control">Controls</a><a href="#cookie-contact">Contact</a></aside>
        <article>
          <section id="cookie-use"><p className="eyebrow">01</p><h2>Our use of browser storage</h2><p>This front-end demonstration uses local browser storage to remember bag and wishlist selections between visits. It does not currently set advertising, personalisation or analytics cookies.</p></section>
          <section id="cookie-essential"><p className="eyebrow">02</p><h2>Strictly necessary functions</h2><p>Stored values contain product identifiers, quantities and selected options. They support the shopping-bag experience on your device and are not transmitted by this implementation.</p></section>
          <section id="cookie-third-party"><p className="eyebrow">03</p><h2>Third-party services</h2><p>No social-media widgets, advertising pixels or third-party analytics scripts are configured. If production services are added, this notice and any required consent controls must be updated before launch.</p></section>
          <section id="cookie-control"><p className="eyebrow">04</p><h2>How to clear stored data</h2><p>You can remove items within the bag or wishlist, or clear site data using your browser settings. Blocking local storage may prevent those selections from remaining available after a refresh.</p></section>
          <section id="cookie-contact"><p className="eyebrow">05</p><h2>Questions</h2><p>For questions about browser storage, email <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a> or read our <Link to="/privacy">privacy policy</Link>.</p></section>
        </article>
      </div>
    </main>
  );
}

export default Cookies;
